import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function NewSoftwareResourcesLandingPage({
  page: { MainContent, breadCrumbList },
}) {
  const HeroComponent = React.lazy(() =>
    import('./new-software-resources-hero-component')
  );
  const SoftwareResourceSearchRootComponent = React.lazy(() =>
    import('./software-resources-search/SoftwareResourceSearchRootComponent')
  );

  return (
    <div className="software resources">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
        <SoftwareResourceSearchRootComponent />
      </Suspense>
    </div>
  );
}

export default NewSoftwareResourcesLandingPage;
